import UserRoute from './UserRoute';

export default UserRoute;
